export const TOGGLE_NAVBAR = 'TOGGLE_NAVBAR';
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const TOGGLE_SIDEBAR_MOBILE = 'TOGGLE_SIDEBAR_MOBILE';
export const TOGGLE_FOOTER = 'TOGGLE_FOOTER';
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
//Session
export const SUPERVISOR_SESSION_ERROR = 'SUPERVISOR_SESSION_ERROR';
export const DATALOAD_ERROR = "DATALOAD_ERROR";
//Admin
export const SUPERVISOR_DATA_LOADING = 'SUPERVISOR_DATA_LOADING';
export const SUPERVISOR_DATA_SUCCESS = 'SUPERVISOR_DATA_SUCCESS';
export const SUPERVISORLIST_DATA_LOADING = 'SUPERVISORLIST_DATA_LOADING';
export const SUPERVISORLIST_DATA_SUCCESS = 'SUPERVISORLIST_DATA_SUCCESS';
export const SUPERVISOR_CREATE_LOADING = 'SUPERVISOR_CREATE_LOADING';
export const SUPERVISOR_CREATE_SUCCESS = 'SUPERVISOR_CREATE_SUCCESS';
export const SUPERVISOR_BALANCE_LOADING = 'SUPERVISOR_BALANCE_LOADING';
//Stats
export const STATS_DATA_LOADING = 'STATS_DATA_LOADING';
export const STATS_DATA_SUCCESS = 'STATS_DATA_SUCCESS';
//Exchange Rate
export const EXCHANGERATE_DATA_LOADING = "EXCHANGERATE_DATA_LOADING";
export const EXCHANGERATE_DATA_SUCCESS = "EXCHANGERATE_DATA_SUCCESS";
//Client
export const CLIENTLIST_DATA_LOADING = "CLIENTLIST_DATA_LOADING";
export const CLIENTLIST_DATA_SUCCESS = "CLIENTLIST_DATA_SUCCESS";
export const CLIENT_DATA_LOADING = "CLIENT_DATA_LOADING";
export const CLIENT_DATA_SUCCESS = "CLIENT_DATA_SUCCESS";
export const ISSUERCONFIG_DATA_LOADING = "ISSUERCONFIG_DATA_LOADING";
export const ISSUERCONFIG_DATA_SUCCESS = "ISSUERCONFIG_DATA_SUCCESS";
//Tranche
export const TRANCHE_DATA_LOADING = "TRANCHE_DATA_LOADING";
export const TRANCHE_DATA_SUCCESS = "TRANCHE_DATA_SUCCESS";
//Agatha Config
export const AGATHACONFIG_DATA_LOADING = "AGATHACONFIG_DATA_LOADING";
export const AGATHACONFIG_DATA_SUCCESS = "AGATHACONFIG_DATA_SUCCESS";
//Agatha Balance
export const AGATHABALANCE_DATA_LOADING = "AGATHABALANCE_DATA_LOADING";
export const AGATHABALANCE_DATA_SUCCESS = "AGATHABALANCE_DATA_SUCCESS";
//Transaction
export const TRANSACTIONLIST_DATA_LOADING = 'TRANSACTIONLIST_DATA_LOADING';
export const TRANSACTIONLIST_DATA_SUCCESS = 'TRANSACTIONLIST_DATA_SUCCESS';
export const TRANSACTION_DATA_LOADING = 'TRANSACTION_DATA_LOADING';
export const TRANSACTION_DATA_SUCCESS = 'TRANSACTION_DATA_SUCCESS';
//Execution
export const EXECUTIONLIST_DATA_LOADING = 'EXECUTIONLIST_DATA_LOADING';
export const EXECUTIONLIST_DATA_SUCCESS = 'EXECUTIONLIST_DATA_SUCCESS';
export const EXECUTION_DATA_LOADING = 'EXECUTION_DATA_LOADING';
export const EXECUTION_DATA_SUCCESS = 'EXECUTION_DATA_SUCCESS';
//Log
export const SUPERVISORLOGINLIST_DATA_LOADING = 'SUPERVISORLOGINLIST_DATA_LOADING';
export const SUPERVISORLOGINLIST_DATA_SUCCESS = 'SUPERVISORLOGINLIST_DATA_SUCCESS';
export const SUPERVISORLOGIN_DATA_LOADING = 'SUPERVISORLOGIN_DATA_LOADING';
export const SUPERVISORLOGIN_DATA_SUCCESS = 'SUPERVISORLOGIN_DATA_SUCCESS';
export const SUPERVISORACTIONLIST_DATA_LOADING = 'SUPERVISORACTIONLIST_DATA_LOADING';
export const SUPERVISORACTIONLIST_DATA_SUCCESS = 'SUPERVISORACTIONLIST_DATA_SUCCESS';
export const SUPERVISORACTION_DATA_LOADING = 'SUPERVISORACTION_DATA_LOADING';
export const SUPERVISORACTION_DATA_SUCCESS = 'SUPERVISORACTION_DATA_SUCCESS';

//Access Rights
export const VFASPACCESSRIGHTSLIST_DATA_LOADING = "VFASPACCESSRIGHTSLIST_DATA_LOADING";
export const VFASPACCESSRIGHTSLIST_DATA_SUCCESS = "VFASPACCESSRIGHTSLIST_DATA_SUCCESS";
export const DEFAULTACCESSRIGHTSLIST_DATA_LOADING = 'DEFAULTACCESSRIGHTSLIST_DATA_LOADING';
export const DEFAULTACCESSRIGHTSLIST_DATA_SUCCESS = 'DEFAULTACCESSRIGHTSLIST_DATA_SUCCESS';
export const SUPERVISORACCESSRIGHTSLIST_DATA_LOADING = 'SUPERVISORACCESSRIGHTSLIST_DATA_LOADING';
export const SUPERVISORACCESSRIGHTSLIST_DATA_SUCCESS = 'SUPERVISORACCESSRIGHTSLIST_DATA_SUCCESS';

//export const  = "";


